/* Studio photo backdrop normaliser: finds a pale studio backdrop (white, peach, lilac, cream, even a soft vertical gradient) and turns it to pure white so it blends into the page card. cb(blobUrl|"white"|null). */
function ppStudioNorm(src,cb,maxW){
  var t=new Image();t.crossOrigin="anonymous";
  t.onload=function(){
    try{
      var s=Math.min(1,(maxW||1000)/t.naturalWidth),w=Math.max(16,Math.round(t.naturalWidth*s)),h=Math.max(16,Math.round(t.naturalHeight*s));
      var c=document.createElement("canvas");c.width=w;c.height=h;var x=c.getContext("2d");x.drawImage(t,0,0,w,h);
      var L=x.getImageData(2,0,1,h).data,R=x.getImageData(w-3,0,1,h).data,bg=[],y,k,bad=0,minc=255,maxd=0;
      for(y=0;y<h;y++){
        var o=y*4;if(L[o+3]<250||R[o+3]<250)return cb(null);
        var dd=0,row=[];
        for(k=0;k<3;k++){dd=Math.max(dd,Math.abs(L[o+k]-R[o+k]));row.push((L[o+k]+R[o+k])/2);minc=Math.min(minc,row[k])}
        if(dd>12)bad++;bg.push(row)
      }
      if(minc<200||bad>h*0.04)return cb(null);
      /* smooth the backdrop estimate down the rows */
      var win=Math.max(3,Math.round(h/40)),sm=[],a,b,sum,n;
      for(y=0;y<h;y++){a=Math.max(0,y-win);b=Math.min(h-1,y+win);var r=[0,0,0];n=0;for(var j=a;j<=b;j++){for(k=0;k<3;k++)r[k]+=bg[j][k];n++}sm.push([r[0]/n,r[1]/n,r[2]/n])}
      var white=true;for(y=0;y<h;y++)if(sm[y][0]<250||sm[y][1]<250||sm[y][2]<250){white=false;break}
      if(white)return cb("white");
      var im=x.getImageData(0,0,w,h),d=im.data,i,p=0,rr,gg,bb;
      for(y=0;y<h;y++){rr=255/sm[y][0];gg=255/sm[y][1];bb=255/sm[y][2];
        for(var xx=0;xx<w;xx++){d[p]=Math.min(255,d[p]*rr);d[p+1]=Math.min(255,d[p+1]*gg);d[p+2]=Math.min(255,d[p+2]*bb);p+=4}}
      x.putImageData(im,0,0);
      c.toBlob(function(bl){cb(bl?URL.createObjectURL(bl):null)},"image/jpeg",.93);
    }catch(e){cb(null)}
  };
  t.onerror=function(){cb(null)};t.src=src;
}

/* Studio photos (Danish Design lilac backdrop; cat products: any pale studio backdrop is turned white): blend the backdrop into the page's green card. Collections keep a white card. */
(function(){
  var LPx=window.LIVE_PRODUCT;
  var isCat=!!(LPx&&LPx.tags&&[].concat(LPx.tags).some(function(t){return String(t).toLowerCase()==="cat"}));
  if(!LPx||(LPx.vendor!=="Danish Design"&&!isCat))return;
  document.documentElement.classList.add("dd-pdp");
  var seen={};
  function sample(img){
    var src=img.currentSrc||img.src; if(!src||img.dataset.ddp)return; img.dataset.ddp="1";
    var key=src.split("?")[0];
    if(isCat){
      ppStudioNorm(src,function(r){if(!r)return;if(r!=="white"){img.removeAttribute("srcset");img.src=r}img.classList.add("ddp")},1100);
      return;
    }
    if(key in seen){ if(seen[key])img.classList.add("ddp"); return; }
    var t=new Image(); t.crossOrigin="anonymous";
    t.onload=function(){
      try{
        var c=document.createElement("canvas"),w=24,h=24; c.width=w;c.height=h;
        var x=c.getContext("2d"); x.drawImage(t,0,0,w,h);
        var pts=[[1,1],[w-2,1],[1,h-2],[w-2,h-2],[w>>1,1],[1,h>>1],[w-2,h>>1]],ok=0;
        pts.forEach(function(p){var d=x.getImageData(p[0],p[1],1,1).data;
          if(d[0]>236&&d[1]>234&&d[2]>240&&d[2]-d[1]>=2&&d[2]-d[1]<=14)ok++;});
        seen[key]=ok>=5; if(seen[key])img.classList.add("ddp");
      }catch(e){seen[key]=false;}
    };
    t.onerror=function(){seen[key]=false;};
    t.src=src;
  }
  function scan(){document.querySelectorAll(".n2-gal img").forEach(sample);}
  var mo=new MutationObserver(function(){scan();});
  function start(){scan();mo.observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start);else start();
})();

/* Colour variants: show the photo that belongs to the chosen variant (the theme event only carries the variant title). */
(function(){
  function key(u){return String(u||"").split("?")[0].split("/").pop().replace(/_\d+x\d*(?=\.)/,"").toLowerCase()}
  document.addEventListener("n2:variant",function(e){
    var LP=window.LIVE_PRODUCT;
    if(!LP||!e.detail||!e.detail.title)return;
    var v=(LP.variants||[]).filter(function(x){return x.title===e.detail.title})[0];
    var fi=v&&(v.featured_image||(v.featured_media&&v.featured_media.preview_image));
    if(!fi||!fi.src)return;
    var k=key(fi.src),idx=-1;
    [].slice.call(document.querySelectorAll(".n2-slide img")).forEach(function(im,i){if(idx<0&&key(im.currentSrc||im.src)===k)idx=i});
    if(idx<0)return;
    var th=document.querySelector('.n2-th[data-gi="'+idx+'"]');
    if(th)th.click();
  });
})();
